import React from "react";

function BookingNum() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" >
      <symbol id="booking-icon" viewBox="0 0 36.52 42.005">
        <g fill="var(--secondary-text-color)">
          
         
          <path
            d="M1.587 289.063v42.005h25.03l11.491-9.441v-32.564zm1.826 1.5h32.869v30H25.326v9H3.414zm23.738 31.5h7.839l-7.839 6.44z"
            transform="translate(-1.588 -289.063)"
          ></path>
           
          <text 
            fontSize="12"
            fontWeight="700"
            transform="translate(-3 -290) translate(6 306)"
          >
            <tspan x="0" y="0">
              Book 
            </tspan>
            
          </text>
          
           
          <text 
            fontSize="13"
            fontWeight="700"
            transform="translate(-2 -277) translate(6 306)"
          >
            <tspan x="0" y="0">
              ing
            </tspan>
            
          </text>
          
        </g>
      </symbol>
      <use xlinkHref="#booking-icon"></use>
    </svg>
  );
}

export default BookingNum;
